export default __webpack_public_path__ + "static/media/card.a3ef4604.svg";